module.exports = __webpack_public_path__ + "static/media/img-5.5d657187.jpg";